// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "network.cvl",
    name: "CVL Wallet",
    homepage: "https://cvl.network",
    image_id: "e4eff15a-35d5-49fe-047f-33e331f46400",
    app: {
        browser: "https://app.cvl.network/",
        ios: "https://apps.apple.com/ru/app/cvl-wallet/id6444357628",
        android: "https://play.google.com/store/apps/details?id=llp.bc_group.cvl_wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://app.cvl.network/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map